const namespace = 'hokodo';
export const createPrefix = prefix => name => `${namespace}/${prefix}/${name}`;
export const createAction = type => payload => ({ type, payload });

export default {
  createPrefix,
  createAction,
};
